/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var _isSound = false; //preload
	
	(0, _module.preload)(); //toggleHeader
	
	(0, _module.toggleHeader)(); //pageTop
	
	(0, _module.pageTop)(); //showMovie
	
	(0, _module.showMovie)(); //tabSwitching
	// import {tabSwitching} from "../include/module";
	// tabSwitching();
	//anchorLink
	
	(0, _module.anchorLink)(); //soundPlay
	
	(0, _module.soundCommon)(); //showItem
	
	(0, _module.showItem)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.soundPlay = soundPlay;
	exports.soundStop = soundStop;
	exports.soundPause = soundPause;
	exports.showItem = exports.anchorLink = exports.tabSwitchingCampaign = exports.tabSwitching = exports.showMovie = exports.pageTop = exports.preload = exports.toggleHeader = exports.soundCommon = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	var _isSound = false;
	var windowW = $(window).width();
	var windowH = $(window).innerHeight(); // var commonBtn = document.getElementById('soundBtn');
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	//  音再生関連
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	function soundPlay() {
	  $('#soundBtn').addClass('on').removeClass('off');
	  _isSound = true;
	  var sound = document.getElementById("sound");
	  sound.muted = false; // sound.currentTime = 0; //先頭に戻す
	
	  sound.play();
	}
	
	function soundStop() {
	  //document.getElementById("sound").pause();
	  $('#soundBtn').removeClass('on').addClass('off');
	  var sound = document.getElementById("sound");
	  sound.muted = true;
	  _isSound = false;
	  sound.pause();
	}
	
	function soundPause() {
	  $('#soundBtn').removeClass('on').addClass('off');
	} // ------------------------------------------------------------------------
	// commonSound
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var soundCommon = function soundCommon() {
	  $('#soundBtn').on('click', function () {
	    var sound = document.getElementById("sound");
	
	    if (!_isSound) {
	      sound.muted = false;
	      soundPlay();
	    } else {
	      sound.muted = true;
	      soundStop();
	    }
	  }); //ページが見えなくなったら音を止める
	
	  document.addEventListener("visibilitychange", function (e) {
	    if (_isSound) {
	      if (document.hidden) {
	        sound.muted = true;
	        sound.pause();
	      } else {
	        sound.muted = false;
	        sound.play();
	      }
	    }
	  });
	}; // toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.soundCommon = soundCommon;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	      setTimeout(function () {// $('#st-Header_Navi').css({'display':'none'});
	      }, 0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	
	    if (scrollPosition >= 70) {
	      $("#st-Top").removeClass('st-Top-Hidden');
	    } else {
	      $("#st-Top").addClass('st-Top-Hidden');
	    }
	  });
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 700;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe'); // open
	
	  $('.js-Youtube').on('click', function () {
	    if (_isSound) {
	      sound.muted = true;
	      sound.pause();
	    }
	
	    var dataID = $(this).attr('data-youtube');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    if (_isSound) {
	      sound.muted = false;
	      sound.play();
	    }
	
	    $('#movie-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    }); //
	    // $modal.stop().fadeOut(300, function(){
	    //   $content.children('iframe').remove();
	    // });
	  });
	}; // ------------------------------------------------------------------------
	// tabSwitching
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var tabSwitching = function tabSwitching() {
	  $('.tab-item').on('click', function () {
	    var idx = $('.tab-item').index(this);
	    $(this).addClass('current').siblings('.tab-item').removeClass('current');
	    $(this).closest('.tab').prev('.panel').find('.panel-item').removeClass('is-show');
	    $('.panel-item').eq(idx).addClass('is-show');
	  });
	}; // ------------------------------------------------------------------------
	// tabSwitchingCampaign
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.tabSwitching = tabSwitching;
	
	var tabSwitchingCampaign = function tabSwitchingCampaign() {
	  $('.tab-item').on('click', function () {
	    var idx = $('.tab-item').index(this);
	    $(this).addClass('current').siblings('.tab-item').removeClass('current');
	    $(this).closest('.tab').next('.panel').find('.panel-item').removeClass('is-show');
	    $('.panel-item').eq(idx).addClass('is-show');
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.tabSwitchingCampaign = tabSwitchingCampaign;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var __layer = $('.st-Container').attr('data-layer');
	
	  var linkSpeed = 700;
	  var linkAdjust = 0; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  }); //トップページ内のヘッダーリンク
	
	  $(".header-link").on("click", function () {
	    if (__layer == 'first') {
	      var linkHref = $(this).attr("href");
	      var linkHash = linkHref.replace("./", "");
	      var linkTarget = $(linkHash == "#" || linkHash == "" ? 'html' : linkHash);
	      var linkPosition = linkTarget.offset().top;
	
	      if (headerFlag) {
	        stHeader.classList.remove('opened');
	        stHeaderNav.classList.remove('opened');
	        headerButton.classList.remove('opened');
	        stHeaderBg.classList.remove('opened');
	        stHeader.classList.add('closed');
	        stHeaderNav.classList.add('closed');
	        headerButton.classList.add('closed');
	        stHeaderBg.classList.add('closed');
	        headerFlag = false;
	      }
	
	      $("html, body").animate({
	        scrollTop: linkPosition - linkAdjust
	      }, linkSpeed, "easeInOutQuint");
	      return false;
	    }
	  });
	};
	/*******************************************************
	
	showItem
	
	********************************************************/
	
	
	exports.anchorLink = anchorLink;
	
	var showItem = function showItem() {
	  var targetPositionAdd;
	  targetPositionAdd = 30;
	  var scrollPosition = $(window).scrollTop();
	  $(window).on("load resize", function () {
	    windowW = $(window).width();
	    windowH = $(window).innerHeight();
	  }); //ファーストビュー内にあるアイテム
	
	  $('.anim_Item').each(function () {
	    var targetPosition = $(this).offset().top;
	
	    if (targetPosition < windowH + scrollPosition) {
	      $(this).addClass("show");
	    }
	  }); //ファーストビューより下にあるアイテム（スクロールで表示）
	
	  $(window).on('scroll', function () {
	    scrollPosition = $(window).scrollTop();
	    $('.anim_Item').each(function () {
	      var targetPosition = $(this).offset().top;
	
	      if (scrollPosition > targetPosition - windowH + targetPositionAdd) {
	        $(this).addClass("show");
	      }
	    }); //スクロール誘導矢印を消す
	    // $(".opening_Item").addClass("hidden");
	  });
	};
	
	exports.showItem = showItem;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js